import React from "react";
import { X, Minus, Plus } from "lucide-react";

export default function CartSidebar({
  cartOpen,
  cartItems,
  setCartOpen,
  updateQuantity,
  removeFromCart,
  openCheckoutForm,
  cartTotal,
}) {
  if (!cartOpen) return null;
  return (
    <>
      {cartItems && (
        <>
          <div
            className="fixed inset-0 bg-black/20 z-40"
            onClick={() => setCartOpen(false)}
          />

          <div className="fixed right-0 top-0 h-full w-full sm:w-96 bg-white z-50 flex flex-col">
            {/* Header */}
            <div className="p-6 border-b flex justify-between items-center">
              <h2 className="font-medium">Cart ({cartItems.length})</h2>
              <button
                onClick={() => setCartOpen(false)}
                className="hover:opacity-60 transition"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Cart Items */}
            <div className="flex-1 overflow-y-auto p-6">
              {cartItems.length === 0 ? (
                <div className="text-center py-20">
                  <p className="text-gray-400 text-sm">
                    Your cart is empty
                  </p>
                </div>
              ) : (
                <div className="space-y-6">
                  {cartItems.map((item) => (
                    <div key={item.cartId} className="flex gap-4">
                      <img
                        src={item.images[1]}
                        alt={item.name}
                        className="w-24 h-24 object-cover"
                      />

                      <div className="flex-1">
                        <h3 className="text-sm font-medium mb-1">
                          {item.name}
                        </h3>
                        <p className="text-xs text-gray-500 mb-3">
                          Size {item.selectedSize}
                        </p>

                        <div className="flex items-center gap-3">
                          <button
                            onClick={() =>
                              updateQuantity(item.cartId, item.quantity - 1)
                            }
                            className="w-6 h-6 border border-gray-300 flex items-center justify-center hover:border-black transition"
                          >
                            <Minus className="w-3 h-3" />
                          </button>

                          <span className="text-sm w-6 text-center">
                            {item.quantity}
                          </span>

                          <button
                            onClick={() =>
                              updateQuantity(item.cartId, item.quantity + 1)
                            }
                            className="w-6 h-6 border border-gray-300 flex items-center justify-center hover:border-black transition"
                          >
                            <Plus className="w-3 h-3" />
                          </button>
                        </div>
                      </div>

                      <div className="text-right">
                        <p className="text-sm font-medium mb-2">
                          ₹{item.price * item.quantity}
                        </p>
                        <button
                          onClick={() => removeFromCart(item.cartId)}
                          className="text-xs text-gray-500 hover:text-black transition"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Footer with Subtotal & Checkout */}
            {cartItems.length > 0 && (
              <div className="border-t p-6">
                <div className="flex justify-between mb-6">
                  <span className="text-sm">Subtotal</span>
                  <span className="font-medium">₹{cartTotal}</span>
                </div>

                <button
                  onClick={openCheckoutForm}
                  className="w-full bg-black text-white py-3 text-sm font-medium hover:bg-gray-800 transition"
                >
                  Checkout
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
